import { env } from '../../lib/env/env';

export const splitIOConfig = {
  SPLIT_IO_KEY: env.getString('SPLIT_IO_KEY') || 'i820sd7alpqv7qdkr6fgj0nk989cadu8guk5',
};
